<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'用户管理'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item  label="用户编码">
							    <el-input clearable v-model="q.usercodeLike"></el-input>
							</el-form-item>
							<el-form-item label="用户名称">
							    <el-input clearable v-model="q.usernameLike"></el-input>
							</el-form-item>
							<el-form-item label="邮箱">
							    <el-input clearable v-model="q.email"></el-input>
							</el-form-item>
							<el-form-item label="用户类型">
								<brselect clearable category="yonghu_leixing" :v="q.usertype" v-model="q.usertype"></brselect>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="　联系人电话">
										<el-input clearable v-model="q.phone"></el-input>
									</el-form-item>
                                    <el-form-item label="状态">
                                        <brselect clearable category="zhuangtai_type" :v="q.status" v-model="q.status"></brselect>
                                    </el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							 <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-table h-mrt30">
            <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%"
					border
            >
                <el-table-column
                        type="index"
                        label="#"
						fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="usercode"
                        label="员工编码/公司编码"
						fixed
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="password"-->
<!--                        label="密码"-->
<!--                        width="120"-->
<!--						:show-overflow-tooltip="true">-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="status"
                        width="90"
                        label="用户状态"
						:show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{scope.row.status|dictname('zhuangtai_type')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="username"
                        label="公司/员工名称"
                        width="250"
						:show-overflow-tooltip="true">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.username}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="email"
                        label="邮箱"
                        width="180"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="联系人电话"
                        width="120"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="deptcode"
                        label="所属部门编码"
                        width="170"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="userdept"
                        label="用户详细部门"
                        width="170"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="deptname"
                        label="部门名称"
                        width="100"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="firstline"
                        label="一线经理"
                        width="100"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="secondline"
                        label="二线经理"
                        width="100"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="organization"
                        label="公司地址/住址机构"
                        width="190"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="ldate"
                        label="更新时间"
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="logintimes"
                        label="登录次数"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="lastlogintime"
                        label="最后登录时间"
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="accountdate"
                        label="账户有效期"
                        width="110"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="area"
                        label="负责区域"
                        width="100"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="lucode"
                        label="更新人编码"
                        width="110"
						:show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="countrytype"
                        label="1-国内/2-国外账户"
                        width="160"
						:show-overflow-tooltip="true">
                </el-table-column>


                <el-table-column
                        fixed="right"
                        label="操作"
                        width="130"
                >

                    <template slot-scope="scope">
                        <el-button
                            class="h-tableLink h-btn" v-if="scope.row.status == '1'"
                            @click="freezeOrThaw(scope.row,0)">冻结</el-button>
                        <el-button
                            class="h-tableLink h-btn" v-if="scope.row.status == '0'"
                            @click="freezeOrThaw(scope.row,1)">解冻</el-button>
                        <el-button
                                class="h-tableLink h-btn"
                                @click="handleEdit(scope.row)">授权</el-button>

                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button type="primary" @click="exportExcel">批量导出</el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService';
    import updownfile from "../../utils/updownfile";
    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //查询属性

                q: {
                    usertype:null,
                    pageSize:10,
                    pageNo:1,
                    total:0,
                },
                f: {
                    usercode:null,
                    password:null,
                    usertype:null,
                    username:null,
                    email:null,
                    phone:null,
                    deptcode:null,
                    userdept:null,
                    deptname:null,
                    firstline:null,
                    secondline:null,
                    status:null,
                    organization:null,
                    cdate:null,
                    ldate:null,
                    logintimes:null,
                    lastlogintime:null,
                    accountdate:null,
                    area:null,
                    lucode:null,
                    countrytype:null,
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.query();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            query(p) {
                ss.UserService.selectAllPage(this.q).then(rd=>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.query();
            },
            handleEdit(r){
                this.$router.push({path: '/basic/user_grant', query: {usercodedata:r.usercode} });
            },
            freezeOrThaw(query,aaa) {
              let q = {
                usercode:query.usercode,
                aaa:aaa,
              }
                ss.UserService.freezeOrThaw(q).then(rd=>{
                  if(rd.f){
                    this.$message({
                      message: '操作成功!',
                      type: 'success'
                    });
                    this.query();
                  }
                })
            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/basic/bscUserInfo/downloadExcel", this.q, "post");
            },
        }
    }
</script>
